







































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { Getter, Action } from "vuex-class";
/** 2023-10-19 invoice [START] */
import requestService from "@/service/requestService";
import PaymentService from "@/service/paymentService";
/** 2023-10-19 invoice [END] */
import { INSPECT_TYPE } from "@/model/InspectType";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import { Utils } from "@/service/util";
import { MESSAGE } from "@/model/Message";
import ButtonInspectResult from "@/components/common/button/ButtonInspectResult.vue";
import Number from "@/shared/filters/Number";
import { SideTab } from "@/model/SideTab";
import { IppanSeibiService } from "@/service/IppanSeibiService";

@Component({
  components: {
    InputNumber,
    appButtonInspectResult: ButtonInspectResult
  },
  filters: {
    Number
  }
})
export default class SideTabRight extends Vue {
  @Prop() disabled: boolean;
  /** 2023-10-19 invoice [START] */
  reqService: requestService;
  pmtService: PaymentService;
  /** 2023-10-19 invoice [END] */
  sktControll: SocketControllers;
  ippanSeibiService: IppanSeibiService;

  /** 2023-10-19 invoice [START] */
  @Getter("shohiyouZn", { namespace: "Shohiyou" })
  subShohiyou: any;
  /** 2023-10-19 invoice [END] */

  @Getter("stateId", { namespace: "SubHeader" })
  stateId: number;

  @Getter("waitPartsSelect", { namespace: "SubHeader" })
  waitPartsSelect: boolean;

  @Getter("isConfirm", { namespace: "Payment" })
  isConfirmPayment: number;

  @Getter("isConfirmNex", { namespace: "Payment" })
  isConfirmPaymentNex: number;

  @Action("editPrice", { namespace: "InspectSeibi" })
  editPrice: any;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */
  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  @Getter("sideTabList", { namespace: "FunctionSetting" })
  sideTabList: any;
  /** 2024-05-02 nextage [END] */
  @Getter("couponLabel", { namespace: "FunctionSetting" })
  couponLabel: string;
  @Getter("optionLabel", { namespace: "FunctionSetting" })
  optionLabel: string;

  sideTabDisp: SideTab[] = [];

  hasBtn: boolean = false;

  totalBaseZn: number = 0;
  totalBaseZk: number = 0;
  totalBCalcZk: number = 0;
  totalAllZn: number = 0;
  totalAllZk: number = 0;
  totalACalcZk: number = 0;

  isExitConnectSocket: boolean = false;

  public utils: Utils = new Utils();

  @Watch("sideTabList")
  copySideTabList() {
    // 元の値とは別に書き換え保持するので複製
    this.sideTabDisp = this.utils.deepCopy(this.sideTabList);
    this.sideTabDisp.forEach((tab: any, i: number) => {
      if (this.ippanSeibiService.isIppanSeibi) {
        tab.title1 = tab.title1.replace('法定57項目', '').replace('車検代金', '整備代金');
      }
      if( tab.title1 == '割引/クーポン' ) { tab.title1 = this.couponLabel; }
      if( tab.title1 == '手数料/オプション' ) { tab.title1 = this.optionLabel; }
      if( tab.title1 == '保証/その他' ) { tab.title1 = this.optionLabel; } // ネクステージ用項目の置き換え
    });
  }

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeCd")
  connectSocket() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.uketsukeCd || this.isExitConnectSocket) { return; }
    this.isExitConnectSocket = true;

    this.sktControll = new SocketControllers(this);
    this.sktControll.socketEntry("estimateListSubscription",this.onEditPrice); // catchSocket:ソケット仮01
    this.sktControll.connectSocket();
  }

  created() {
    if (this.$route.name == "statusresult") {
      this.hasBtn = false;
    } else {
      this.hasBtn = true;
    }
    this.connectSocket();
    /** 2023-10-23 disp uchizei (invoice part 8) [START] */
    this.reqService = new requestService();
    this.pmtService = new PaymentService();
    /** 2023-10-23 disp uchizei (invoice part 8) [END] */
    this.ippanSeibiService = new IppanSeibiService();
    this.copySideTabList();
  }

  get sum() { // 税込みの合算
    this.totalCalc();
    if ( this.isExcludingTax ) {
      return this.totalACalcZk;
    } else {
      return this.totalAllZk;
    }
  }

  totalCalc() {
    let paymentId: number = -1;
    let requireId: number = -1;
    this.sideTabDisp.forEach((tab: any, i: number) => {
      if ( tab.router == "paymentdetail" ) {
        paymentId = i;
      } else if ( tab.router == "requiredetail" ) {
        requireId = i;
      } else {
        this.onUpdate(tab.router);
      }
    });

    if ( paymentId >= 0 ) {
      const promise = this.pmtService.setTotalCalc();
      Promise.all([promise]).then(() => {
        const state = this.pmtService.getTotalCalc();
        this.totalAllZn = state.totalSumZn;
        this.totalAllZk = state.totalSumZk;
        this.totalACalcZk = state.totalCalcZk;
        // paymentdetail("車検代金 合計")
        this.sideTabDisp[paymentId].priceDisp = this.isExcludingTax? state.totalCalcZk : state.totalSumZk;
        this.sideTabDisp[paymentId].priceSub = state.totalSumZn;
        this.sideTabDisp[paymentId].confirm = this.isConfirmPayment;
      });
    }
    
    if ( requireId >= 0 ) {
      const promise2 = this.pmtService.setTotalCalcNex();
      Promise.all([promise2]).then(() => {
        const state = this.pmtService.getTotalCalcNex();
        this.totalBaseZn = state.totalSumZn;
        this.totalBaseZk = state.totalSumZk;
        this.totalBCalcZk = state.totalCalcZk;
        // requiredetail(車検最低料金)
        this.sideTabDisp[requireId].priceDisp = this.isExcludingTax? state.totalCalcZk : state.totalSumZk;
        this.sideTabDisp[requireId].priceSub = state.totalSumZn;
        this.sideTabDisp[requireId].confirm = this.isConfirmPaymentNex;
      });
    }
    
  }

  // 各項目の金額を更新する
  onUpdate(key: string) {

    if ( key != "paymentdetail" && key != "requiredetail" ) {
      let zn: number = 0;
      let zk: number = 0;
      let flg: number = 0;
      let abs: number = 0;
      let pays: any = { zn:0 , zk:0 , flg:0 };
      // 通常項目
      if ( key == "inspectioncost" ) {
        pays = this.pmtService.getTotalShohiyou();
      }
      if ( key == "discountcoupon" ) {
        pays = this.pmtService.getTotalCoupon();
        abs = 1;
      }
      if ( key == "userlegal56" ) {
        pays = this.pmtService.getSumLegal56();
      }
      if ( key == "userrecommend" ) {
        pays = this.pmtService.getSumRecommend();
      }
      if ( key == "paymentdetail" ) {
        // priceDispは関数呼び出し+税込み、priceSubは税抜き固定の特殊処理
        pays = { zn:0 , zk:0 , flg:this.isConfirmPayment };
      }
      if ( key == "option" ) {
        pays = this.pmtService.getTotalOption();
        abs = 1;
      }

      // 以下ネクステージ用
      // 表示の仕方の問題で、総合計の金額には影響がない
      if ( key == "userlegal56Nex1" ) {
        pays = this.pmtService.getSumPriceNex1();
      }
      if ( key == "userlegal56Nex2" ) {
        pays = this.pmtService.getSumPriceNex2();
      }
      if ( key == "requiredetail" ) {
        // priceDispは関数呼び出し+税込み、priceSubは税抜き固定の特殊処理
        pays = { zn:0 , zk:0 , flg:this.isConfirmPaymentNex };
      }
      if ( key == "soukouhosho" ) {
        pays = this.pmtService.getTotalOption();
        abs = 1;
      }
      // ここまでネクステージ用

      // 配列の位置を特定
      this.sideTabDisp.forEach((tab: any, i: number) => {
        if (tab.router == key) {
          // 税込み税抜きで格納先を入れ替える
          if ( this.isExcludingTax ) {
            tab.priceDisp = abs==1?Math.abs(pays.zn):pays.zn;
            tab.priceSub = pays.zk;
          } else {
            tab.priceDisp = abs==1?Math.abs(pays.zk):pays.zk;
            tab.priceSub = pays.zn;
          }
          tab.confirm = pays.flg;
        }
      });
    }
  }


  onActive(key: string) {
    this.sideTabDisp.forEach((tab: any, i: number) => {
      if (tab.router == key) {
        tab.isActive = true;
      } else {
        tab.isActive = false;
      }
    });
    this.$forceUpdate();
  }

  // 社店拠点ごとの表示制御は管理画面で。 同じ社店拠点の状態毎の表示制御はここで行う
  isdisplay(key: string) {
    // 一般整備：法定費用を非表示
    if ( this.ippanSeibiService.isIppanSeibi && key == "inspectioncost" ) { return false; }
    return true;
  }

  onSelect(key: string) {
    this.sideTabDisp.forEach((tab: any, i: number) => {
      if (tab.router == key) {
        this.$emit('onSelect');
        this.onActive(tab.router);
        this.$router.push({ name: tab.router });
      }
    });
  }

  onConfirm(key: string) {
    this.sideTabDisp.forEach((tab: any, i: number) => {
      if (tab.router == key) {
        tab.isConfirm = true;
        this.onUpdate(tab.router);
      }
    });
  }

  nowActive() {
    this.sideTabDisp.forEach((item: any,index: number) => {
      if ( item.isActive && item.calcLabel == "legal56" ) {
        return index;
      }
      if ( item.isActive && item.calcLabel == "recommend" ) {
        return index;
      }
      if ( item.isActive && item.calcLabel == "nextage" ) {
        return index;
      }
    });
    return -1;
  }

  isConfirm(flag: number) {
    return flag == 1;
  }

  textConfirm(flag: number) {
    return flag ? "確" : "未";
  }

  onEditPrice(frame: any) {
    let id: number = this.nowActive();
    if (id<0) {
      const body = this.utils.getWSData(frame);
      this.editPrice(body);
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedInspections
      });
      this.totalCalc();
    }
  }

  onPlus(event: any) {
    event.stopPropagation(); // アイコンの選択に留め、タブの選択動作はキャンセルする
    // this.$set(this.isOnPlus, index,  !this.isOnPlus[index]);
  }

}
